/* eslint-disable camelcase */
import {
  getLandingView,
  initUser,
  mamcAuthenticate,
  mamcResetPassword,
  posShopForgotPassword,
} from '../AppServices';

import {
  loginLogo,
  classRoom_logo,
  helpIcon,
  hospitalLiveLogo,
  login_background_web,
  resetPassword,
} from '../images';

import LoginHoc from './Login';
import AuthenticatorHoc from './Authenticator';

import ResetPasswordHOC from './ResetPassword';
import ForgotPasswordHOC from './ForgotPassword';
import ChangePasswordHoc from './ChangePassword';

import SignupForm from '../Signup';
// import ContactUsForm from '../ContactUs';
import PaymentScreen from '../Payment/PaymentScreen';

const getAuthTemplate = () => {
  const payment = PaymentScreen({
    mamcAuthenticate,
    images: {
      bgImage: login_background_web,
      helpIcon,
      loginLogo,
      hospitalLiveLogo,
      classRoom_logo,
    },
  });

  const Signup = SignupForm({
    mamcAuthenticate,
    images: {
      bgImage: login_background_web,
      helpIcon,
      loginLogo,
      hospitalLiveLogo,
      classRoom_logo,
    },
  });

  // const ContactUs = ContactUsForm({
  //   mamcAuthenticate,
  //   images: {
  //     bgImage: login_background_web,
  //     helpIcon,
  //     loginLogo,
  //     hospitalLiveLogo,
  //     classRoom_logo,
  //   },
  // });

  const Login = LoginHoc({
    mamcAuthenticate,
    images: {
      bgImage: login_background_web,
      helpIcon,
      loginLogo,
      hospitalLiveLogo,
      classRoom_logo,
    },
  });
  const ResetPassword = ResetPasswordHOC({
    mamcResetPassword,
    images: {
      bgImage: login_background_web,
      helpIcon,
      loginLogo,
      hospitalLiveLogo,
      classRoom_logo,
      resetPassword,
    },
  });

  const ForgotPassword = ForgotPasswordHOC({
    posShopForgotPassword,
    images: {
      bgImage: login_background_web,
      helpIcon,
      loginLogo,
      hospitalLiveLogo,
      classRoom_logo,
      resetPassword,
    },
  });
  const Authenticator = AuthenticatorHoc({
    initUser,
    landingView: getLandingView,
    loginView: '/',
  });
  const ChangePassword = ChangePasswordHoc({});

  return {
    Login,
    Signup,
    payment,
    // ContactUs,
    Authenticator,
    ResetPassword,
    ForgotPassword,
    ChangePassword,
  };
};

const authTemplates = getAuthTemplate();

export default authTemplates;
